<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<!--<div class="sf-col sf-col-7">-->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pc-idx-num-wm-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-12">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-idx-num-wm-graph ref="graph" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-wm-graph>
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-8">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-idx-num-wm-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-idx-num-wm-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcIdxNumWmSearch from './Search/PcIdxNumWmSearch.vue';
import PcIdxNumWmTable from './Table/PcIdxNumWmTable.vue';
import PcIdxNumWmGraph from './Table/PcIdxNumWmGraph.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcIdxNumWmSearch, PcIdxNumWmTable, PcIdxNumWmGraph },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			this.$refs.search.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style></style>
